/**
 * Aura AGM preset (my_preset / sg / aura / agm) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = My Preset(클라이언트 커스텀)에서 온 AGM 선택 또는 task code CAU002.
 *   priority 55 (인코퍼레이션 50 보다 높게 — AGM 카테고리에서 우선).
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraAgmPanel from './components/PreSetAuraAgmPanel.vue';
import { auraAgmFlow } from './chatflows/auraAgmFlow';

export { default as PreSetAuraAgmPanel } from './components/PreSetAuraAgmPanel.vue';
export { auraAgmFlow } from './chatflows/auraAgmFlow';

/** 공통코드 — Aura AGM 은 CAU002 로 발급됨. */
export const AURA_AGM_TASK_CODES: string[] = ['CAU002'];

export function matchesAuraAgm(sel: PreSetSelection): boolean {
  // 코드 전용 매칭(CAU002). 이름 fallback 제거 — 고객사 접두어 코드가 유일 라우팅 키.
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_AGM_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraAgmPreset(): void {
  registerChatFlow(auraAgmFlow);
  registerPanel({
    id: 'aura-agm',
    priority: 55,
    match: (sel) => matchesAuraAgm(sel),
    component: PreSetAuraAgmPanel,
    meta: { docType: 'SG_AGM_PRE', studio: true },
  });
}

registerAuraAgmPreset();
